module.exports = __webpack_public_path__ + "img/services-stripes-right.19307959.png";